import React from 'react'

const Peraturan = () => {
  const reports = [
    {
      title: "POJK 35 Tahun 2024",
      category: "Peraturan",
      image: "/images/asset/cover-peraturan.svg",
      file: "/pdfs/POJK 35 Tahun 2024 Perizinan dan Kelembagaan Dana Pensiun.pdf",
    },
    {
      title: "POJK 27 Tahun 2023",
      category: "Peraturan",
      image: "/images/asset/cover-peraturan.svg",
      file: "/pdfs/POJK 27 Tahun 2023 Penyelenggaraan Usaha Dana Pensiun.pdf",
    },
    {
      title: "POJK 4 Tahun 2021",
      category: "Peraturan",
      image: "/images/asset/cover-peraturan.svg",
      file: "/pdfs/pojk 4-2021.pdf",
    },
    {
      title: "POJK 44 Tahun 2020",
      category: "Peraturan",
      image: "/images/asset/cover-peraturan.svg",
      file: "/pdfs/pojk 44-2020.pdf",
    },
    {
      title: "UU No. 11 Tahun 1992",
      category: "Peraturan",
      image: "/images/asset/cover-peraturan.svg",
      file: "/pdfs/UU Nomor 11 Tahun 1992.pdf",
    },
  ];
  return (
    <>
    <div className="px-4 py-6 sm:px-6 lg:px-12 xl:px-20">
        <h2 className="text-xl font-bold mb-6 font-pontano">Peraturan Terkait Dana Pensiun Toyota Astra</h2>
        <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
          {reports.map((report, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-lg shadow hover:shadow-md transition duration-300 flex flex-col overflow-hidden"
            >
              <img
                src={report.image}
                alt={report.title}
                className="w-full h-[300px] object-cover object-center"
              />
              <div className="flex flex-col p-4 justify-between grow">
                <div className="mb-4">
                  <p className="text-sm text-[#EB0A1E] font-medium mb-1 font-inter">
                    {report.category}
                  </p>
                  <h3 className="text-base font-semibold leading-snug font-pontano">
                    {report.title}
                  </h3>
                </div>
                <a
                  href={report.file}
                  download
                  className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#EB0A1E] text-white text-sm rounded-md hover:bg-red-700 transition self-start font-inter"
                >
                  Download
                  <img
                    src="/images/asset/download.svg"
                    alt="Download"
                    className="w-4 h-4"
                  />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default Peraturan
